import React, { useEffect, useState } from 'react'
import IdleTimeDoughnut from '../../components/IdleTimeDoughnut/ChartWithoutControls'
import { showNotification } from '../../utils/toast.utils'
import * as dashboardService from '../../service/dashboard.service'

const IdletimeWrapperMachineWise = ({
  selectedDate,
  machine,
  selectedShift
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [idletimeData, setIdletimeData] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      if (!selectedDate) {
        setIdletimeData(null)
        return
      }

      try {
        setIsLoading(true)
        setError(null)
        const response = await dashboardService.getIdletimeDataForDay({
          date: selectedDate
        })

        if (response?.data?.success) {
          setIdletimeData(response.data.data.idleTimeMachineWiseData)
        } else {
          setError('Failed to fetch data')
          showNotification('Failed to fetch data', 'error')
        }
      } catch (err) {
        console.error('Error fetching idle time data:', err)
        setError('Network error occurred')
        showNotification('An error occurred while fetching data', 'error')
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [selectedDate])

  if (isLoading) return <p>Loading...</p>
  if (error) return <p>{error}</p>
  if (!idletimeData || !machine?.value || !selectedShift?.value) {
    return <p>No data available.</p>
  }

  const machineData = idletimeData[machine.value]
  const shiftData = machineData?.[selectedShift.value]

  if (!shiftData || Object.keys(shiftData).length === 0) {
    return <p>No idle time recorded for this machine and shift.</p>
  }

  return <IdleTimeDoughnut idleTimeData={shiftData} />
}

export default IdletimeWrapperMachineWise
